export default __webpack_public_path__ + "static/media/kaiza.6e8774e0.png";